import Vue from "vue";
import firebase from "firebase";
import { firestorePlugin, rtdbPlugin } from "vuefire";
import store from "./store";
import router from "./router";
import App from "./App.vue";
import Default from "./layouts/Default.vue";
import Authorized from "./layouts/Authorized.vue";
import vuetify from "./plugins/vuetify";
import { firebaseConfig } from "./firebase.config";

import "./filters/datetime";
import "./filters/personDetails";

import { api } from "@/api";
import "@/styles/global.scss";
// import MetaMixins from "@/mixins/MetaMixins";

Vue.component("Default", Default);
Vue.component("Authorized", Authorized);
Vue.config.productionTip = false;

Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);
console.log("firebaseConfig", firebaseConfig);
firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(async data => {
  store.commit("user/setAuthLoaded", true);
  await store.dispatch("user/updateUser", data);
  if (data && data.uid) {
    // successful login case
    const validateResponse = await api.users.validateUser(data.email);
    const { valid, id: userId } = validateResponse;
    if (!valid) {
      // console.log("not valid");
      await firebase.auth().signOut();
      return router.replace("login").catch();
    } else {
      // console.log("data.uid", data.uid);
      let firstPath = store.state.app.firstPath;
      firstPath = firstPath != "/login" ? firstPath : "/";
      await router
        .replace(firstPath)
        .catch()
        .then(async () => {
          // console.log("iserOd", userId);
          if (userId) {
            await api.users.updateUser({
              id: userId,
              email: data.email,
              provider: data.providerData.map(provider => provider.providerId),
              photoURL: data.photoURL,
              phoneNumber: data.phoneNumber,
              displayName: data.displayName,
              uid: data.uid
            });
          }
        });
    }
  }
});
new Vue({
  router,
  store,
  vuetify,
  // mixins: [MetaMixins],
  render: h => h(App)
}).$mount("#app");
